import { Link } from "react-router-dom";
import { principles, testimonials } from "@/mocks/content";

export default function BrandSection() {
  return (
    <section className="border-y border-background-300/60 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        {/* brand statement */}
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.3fr_1fr]">
          <div>
            <p className="text-xs font-bold tracking-[0.25em] text-primary-600">关于昨日吃瓜</p>
            <h2 className="mt-2 font-display text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
              昨天的热闹，值得
              <span className="text-primary-500">被好好讲一遍</span>
            </h2>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700">
              我们是一群相信「吃瓜也有方法论」的编辑。在这个信息以分钟为单位变形的时代，与其跟着节奏上头，
              不如把昨天发生了什么、谁在什么时候说了什么、哪些细节还悬而未决，一件件摆回桌面上。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              了解我们的方法 <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { n: "118+", l: "期完整复盘", c: "text-primary-600" },
              { n: "40万+", l: "累计围观人次", c: "text-accent-600" },
              { n: "4", l: "个分析栏目", c: "text-secondary-700" },
              { n: "24h", l: "时效内完成梳理", c: "text-foreground-800" },
            ].map((s, i) => (
              <div
                key={i}
                className="rounded-2xl bg-background-50 p-5 text-center ring-1 ring-background-200/70"
              >
                <p className={`font-display text-3xl font-black ${s.c}`}>{s.n}</p>
                <p className="mt-1 text-sm text-foreground-600">{s.l}</p>
              </div>
            ))}
          </div>
        </div>

        {/* principles */}
        <div className="mt-14">
          <div className="mb-6 flex items-center gap-3">
            <span className="flex h-8 items-center rounded-md bg-primary-500 px-3 text-xs font-bold text-background-50">
              编辑部信条
            </span>
            <div className="ornate-line h-px flex-1" />
          </div>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((p, i) => (
              <div key={i} className="rounded-2xl bg-background-50 p-6 ring-1 ring-background-200/70">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary-100 text-secondary-800">
                  <i className={`${p.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-display text-lg font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* testimonials */}
        <div className="mt-14">
          <h2 className="text-center font-display text-2xl font-black text-foreground-950 md:text-3xl">
            读者怎么说
          </h2>
          <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
            {testimonials.map((t, i) => (
              <figure key={i} className="flex flex-col rounded-2xl bg-background-50 p-6 ring-1 ring-background-200/70">
                <i className="ri-double-quotes-l text-3xl text-primary-300" aria-hidden="true" />
                <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                  <span
                    className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-sm font-bold ${t.color}`}
                  >
                    {t.author.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-900">{t.author}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}